import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { onGetUtmsAsync } from './Pension.slice'
import Spinner from '../../components/Spinners/Spinner'
import * as S from './Pension.styles'

const sortUtmsDesc = (a, b) => {
  if (a.targetYear !== b.targetYear) return b.targetYear - a.targetYear

  const monthOrder = {
    enero: 1, january: 1,
    febrero: 2, february: 2,
    marzo: 3, march: 3,
    abril: 4, april: 4,
    mayo: 5, may: 5,
    junio: 6, june: 6,
    julio: 7, july: 7,
    agosto: 8, august: 8,
    septiembre: 9, september: 9,
    octubre: 10, october: 10,
    noviembre: 11, november: 11,
    diciembre: 12, december: 12,
  }

  const aMonth = monthOrder[String(a.targetMonth).toLowerCase()] || 0
  const bMonth = monthOrder[String(b.targetMonth).toLowerCase()] || 0
  return bMonth - aMonth
}

const UtmCard = ({ utm }) => (
  <S.UtmCard>
    <S.CardMain>
      <S.CardIdentity>
        <S.CardPeriod>{utm.targetMonth}</S.CardPeriod>
      </S.CardIdentity>

      <S.CardSide>
        <S.CardValue>{utm.value}</S.CardValue>
      </S.CardSide>
    </S.CardMain>
  </S.UtmCard>
)

const PensionList = () => {
  const { error, loading, utms = [] } = useSelector((state) => state.adminPension)
  const dispatch = useDispatch()

  const sortedUtms = useMemo(() => [...utms].sort(sortUtmsDesc), [utms])

  const groupedByYear = useMemo(
    () =>
      sortedUtms.reduce((acc, utm) => {
        const year = utm.targetYear
        if (!acc[year]) acc[year] = []
        acc[year].push(utm)
        return acc
      }, {}),
    [sortedUtms]
  )

  const years = useMemo(
    () => Object.keys(groupedByYear).map(Number).sort((a, b) => b - a),
    [groupedByYear]
  )

  useEffect(() => {
    dispatch(onGetUtmsAsync())
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <S.Container>
      {loading && <Spinner />}
      {!loading && error && (
        <S.ErrorText>
          No pudimos cargar los valores UTM. Inténtalo de nuevo más tarde.
        </S.ErrorText>
      )}

      {!loading && !error && utms.length === 0 && (
        <S.EmptyState>
          <strong>Aún no hay valores UTM</strong>
          <span>
            Los obtenemos automáticamente desde el SII. Cuando estén listos,
            aparecen aquí.
          </span>
        </S.EmptyState>
      )}

      {!loading && !error && utms.length > 0 && (
        years.map((year) => (
          <S.YearGroup key={year}>
            <S.YearLabel>{year}</S.YearLabel>
            <S.CardsWrapper>
              {groupedByYear[year].map((utm) => (
                <UtmCard key={utm.id} utm={utm} />
              ))}
            </S.CardsWrapper>
          </S.YearGroup>
        ))
      )}
    </S.Container>
  )
}

export default PensionList
